<app-dialog-header [title]="'New Project'"></app-dialog-header>

<div mat-dialog-content>
    <mat-progress-bar
        [appVisible]="loading"
        mode="indeterminate"
        class="tw-mb-1"
    ></mat-progress-bar>
    <div
        class="tw-bg-m3ErrorContainer tw-text-m3OnErrorContainer"
        *ngIf="failed"
    >
        Save Failed
    </div>
    <form [formGroup]="projectForm" class="tw-flex tw-flex-col tw-gap-2">
        <div id="form-grid">
            <mat-form-field appearance="fill">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" />
                <mat-error *ngIf="projectForm.controls.name.errors?.required">
                    Name field is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>External Contact</mat-label>
                <input matInput formControlName="externalContact" />
                <mat-error
                    *ngIf="
                        projectForm.controls.externalContact.errors?.required
                    "
                >
                    External Contact field is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Project Lead</mat-label>
                <mat-select formControlName="projectLead">
                    <mat-option
                        *ngFor="let lead of projectLeads"
                        [value]="lead.id"
                    >
                        {{ lead.firstName }} {{ lead.lastName }}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="projectForm.controls.projectLead.errors?.required"
                >
                    Project Lead field is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Internal Contact</mat-label>

                <mat-select formControlName="internalContact">
                    <mat-option
                        *ngFor="let contact of activeUsers"
                        [value]="contact.id"
                    >
                        {{ contact.firstName }} {{ contact.lastName }}
                    </mat-option>
                </mat-select>

                <mat-error
                    *ngIf="
                        projectForm.controls.internalContact.errors?.required
                    "
                >
                    Internal Contact field is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Start Date</mat-label>
                <input
                    matInput
                    [matDatepicker]="startDatePicker"
                    formControlName="startDate"
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="startDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
                <mat-error
                    *ngIf="this.projectForm.controls.startDate.errors?.required"
                >
                    Start date is required
                </mat-error>
                <mat-error *ngIf="this.projectForm.errors?.pastDate">
                    Start Date must be before End date
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>End Date</mat-label>
                <input
                    matInput
                    [matDatepicker]="endDatePicker"
                    formControlName="endDate"
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="endDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
                <mat-error *ngIf="this.projectForm.errors?.pastDate">
                    Start Date must be before End date
                </mat-error>
            </mat-form-field>
        </div>
        <mat-form-field appearance="fill">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes"></textarea>
        </mat-form-field>

        <div id="form-grid" class="tw-mb-1">
            <mat-form-field floatLabel="always" class="tw-mb-5">
                <mat-label>Estimated Project Hours</mat-label>
                <input
                    matInput
                    type="number"
                    class="hide-arrow"
                    formControlName="estimatedHours"
                    placeholder="0"
                    min="0"
                    onkeydown="return event.key !== 'e' && event.key !== '-' && event.key !== '+'"
                />
                <mat-icon matSuffix>schedule</mat-icon>
                <div matTextSuffix>hours</div>
            </mat-form-field>

            <div class="tw-flex tw-mt-2">
                <mat-checkbox formControlName="nonBillable">
                    Non-Billable
                </mat-checkbox>
            </div>
            <button
                [disabled]="loading"
                mat-raised-button
                class="m3-error"
                (click)="initializeForm()"
            >
                Reset
            </button>
        </div>
    </form>
</div>

<app-dialog-footer
    [disabled]="loading"
    (buttonClick)="onFormSave()"
    (closeClick)="onCloseClick()"
></app-dialog-footer>
